import { render } from "./MenuComponent.vue?vue&type=template&id=5670d88e&scoped=true"
import script from "./MenuComponent.vue?vue&type=script&lang=js"
export * from "./MenuComponent.vue?vue&type=script&lang=js"

import "./MenuComponent.vue?vue&type=style&index=0&id=5670d88e&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/front-digirespi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5670d88e"]])

export default __exports__